module.exports = __webpack_public_path__ + "49b7b2aacd8056837731e4b393add658.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/201608_Presse_AVANGA_SZ_362KB.jpg
// module id = 571
// module chunks = 0